<template>
  <div>
    <button class="btn btn-outline-primary btn-sm" v-on:click="openModal()">
      ค้นหาสินค้า
    </button>
    <div
      class="modal fade"
      id="modal-search-products"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabe3">รายการสินค้า</h5>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              v-on:click="hideModal()"
            ></button>
          </div>
          <div class="modal-body" style="max-height: 80vh; overflow-y: scroll">
            <div class="row">
              <div class="col-md-12">
                <div class="row mb-2">
                  <div class="col-md-12">
                    <input
                      type="text"
                      placeholder="ค้นหา ชื่อสินค้า บาร์โค้ด หรือ ชื่อสามัญ"
                      class="form-control form-control-sm"
                      v-on:input="searchByName()"
                      v-model="search"
                      id="input-seach-product"
                    />
                  </div>
                </div>
                <div class="row mb-2" id="category">
                  <div class="col-12" id="product_category_item">
                    <div class="" style="margin-right: 10px">
                      <a
                        class="text-center bg-white rounded btn btn-outline-secondary categorySearch h3 text-body m-0 fs-6 fw-light"
                        id="defaultProduct"
                        v-on:click="defaultProduct('best-seller')"
                      >
                        สินค้าขายดี
                      </a>
                      <a
                        class="text-center bg-white rounded btn btn-outline-secondary categorySearch h3 text-body m-0 fs-6 fw-light"
                        id="allProducts"
                        v-on:click="allProducts('')"
                      >
                        สินค้าทั้งหมด
                      </a>
                    </div>
                    <div
                      style="
                        border-left: 2px solid #6c757d;
                        height: 2.5rem;
                        margin-right: 10px;
                      "
                    ></div>
                    <template v-for="item in productCategories">
                      <div
                        class=""
                        style="margin-right: 10px"
                        :key="item.id + 'category'"
                      >
                        <a
                          class="text-center rounded btn btn-outline-secondary categorySearch bg-white m-0 text-body fs-6 fw-light"
                          v-on:click="searchByCaterogy(item.id, $event)"
                        >
                          {{ item.name }}
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <template v-for="(product, count) in products">
                <div
                  v-bind:class="`col-md-3 px-2`"
                  v-lazy-container="{ selector: 'img' }"
                  :key="product.id + '' + count"
                  v-on:click="addProductToCart(product.id)"
                  style="cursor: pointer"
                >
                  <div
                    class="block mb-3 rounded px-3 py-2"
                    v-bind:id="`${product.id}-container`"
                  >
                    <div
                      class="pb-2 d-flex align-items-center px-5"
                      style="height: 142px"
                    >
                      <img
                        class="rounded w-100 mh-100"
                        v-bind:data-src="product.product_image"
                        alt=""
                      />
                    </div>
                    <p class="text-start mb-1 text-body product-name fw-400">
                      {{ product.name }}
                    </p>
                    <p class="text-start mb-1 text-body fw-400">
                     คงเหลือ {{ product.amount ? product.amount : 0 }} {{ product.unit_name }}
                    </p>
                    <div class="d-flex justify-content-between">
                      <span class="product-unit-name text-start mb-0">
                        <span class="badge rounded-pill bg-danger">{{
                          product.unit_name
                        }}</span>
                      </span>
                      <span
                        class="text-start text-primary mb-0 product-price fw-500"
                        >฿{{
                          product.retail_price ? product.retail_price : "0.00"
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  :key="'scroll' + count"
                  v-if="count + 1 == pageOffset"
                  id="scrolltrigger"
                  style="margin-top: 10px; height: 50px"
                ></div>
              </template>
              <p v-if="products.length == 0" class="text-center mb-0 fs-3">ไม่พบสินค้าในระบบ</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              v-on:click="confirmProduct()"
              data-bs-dismiss="modal"
            >
              ยืนยัน
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "pos-search",
  props: ["urlSearch", "productCategories"],
  data() {
    return {
      products: [],
      productSearch: "",
      currentPage: 1,
      maxPerPage: 12,
      nextPageUrl: "",
      lastPage: 0,
      timeObserve: 0,
      selectedProducts: [],
      selectedCategory: null,
      search: "",
    };
  },
  mounted() {
    this.allProducts();
    $(document).ready(function () {
      $("#product_category_item").slick({
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        arrows: false,
        variableWidth: true,
        modalIns: null,
      });
    });
    document.addEventListener("keyup", (event) => {
        if (event.keyCode === 13) {
            if ($('#modal-search-products').is(":focus")) {
                this.confirmProduct()
            }
        }
    })
  },
  updated() {
    this.scrollTrigger();
  },
  computed: {
    pageOffset() {
      return this.maxPerPage * this.currentPage;
    },
  },
  methods: {
    hideModal() {
        this.modalIns.hide();
    },
    doSearch: _.debounce(async (_this) => {
      let res = await axios.get(_this.urlSearch, {
        params: {
          search: _this.search,
          categoryId: null,
        },
      });
      activeCategory("#allProducts");
      _this.products = res.data.data.data;
      _this.currentPage = res.data.data.current_page;
      _this.nextPageUrl = res.data.data.next_page_url;
      _this.lastPage = res.data.data.last_page;
      _this.ifNotExistAnyProducts();
    }, 300),
    searchByName() {
      this.doSearch(this);
    },
    openModal() {
      if (!this.modalIns) {
        this.modalIns = new Modal(
          document.getElementById("modal-search-products")
        );
      }
      this.modalIns.show();
    },
    async addProductToCart(product_id) {
      let isProductExist = this.selectedProducts.findIndex(
        (item) => item.product_id == product_id
      );

      if (isProductExist >= 0) {
        this.selectedProducts.splice(isProductExist, 1);
        $(`#${product_id}-container`).removeClass("border border-primary");
      } else {
        this.selectedProducts.push({
          product_id: product_id,
          amount: 1,
        });
        $(`#${product_id}-container`).addClass("border border-primary");
      }
    },
    confirmProduct() {
      let products = this.selectedProducts;
      this.$emit("confirm", products);
      this.selectedProducts = [];
      this.modalIns.hide();
    },
    ifNotExistAnyProducts() {

    },
    scrollTrigger() {
      const observer = new IntersectionObserver(async (entries) => {
        if (entries[0].isIntersecting && entries[0].time != this.timeObserve) {
          this.timeObserve = entries[0].time;
          let res = await axios.get(this.nextPageUrl);
          let newProducts = [...this.products, ...res.data.data.data];
          if (this.currentPage < res.data.data.current_page) {
            this.currentPage = res.data.data.current_page;
            this.nextPageUrl = res.data.data.next_page_url;
            this.lastPage = res.data.data.last_page;
            this.products = newProducts;
          }
        }
      });

      if (document.getElementById("scrolltrigger")) {
        observer.observe(document.getElementById("scrolltrigger"));
      }
    },
    isSelected(product_id) {
      this.selectedProducts.forEach((item) => {
        if (item.product_id == product_id) {
          return true;
        }
      });

      return false;
    },
    async searchByCaterogy(categoryId, event) {
      this.selectedCategory = categoryId;
      let res = await axios.get(this.urlSearch, {
        params: {
          search: this.productSearch,
          categoryId: categoryId,
        },
      });
      activeCategory(event.target);
      this.products = res.data.data.data;
      this.currentPage = res.data.data.current_page;
      this.nextPageUrl = res.data.data.next_page_url;
      this.lastPage = res.data.data.last_page;
      this.ifNotExistAnyProducts();
    },
    async defaultProduct(categoryId) {
      this.selectedCategory = categoryId;
      let res = await axios.get(this.urlSearch, {
        params: {
          search: this.search,
          categoryId: categoryId,
        },
      });
      activeCategory("#defaultProduct");
      this.products = res.data.data.data;
      this.currentPage = res.data.data.current_page;
      this.nextPageUrl = res.data.data.next_page_url;
      this.lastPage = res.data.data.last_page;
      this.ifNotExistAnyProducts();
    },
    async allProducts(categoryId) {
      let search = "";
      let res = await axios.get(this.urlSearch, {
        params: {
          search,
        },
      });
      this.selectedCategory = categoryId;
      activeCategory("#allProducts");
      this.products = res.data.data.data;
      this.currentPage = res.data.data.current_page;
      this.nextPageUrl = res.data.data.next_page_url;
      this.lastPage = res.data.data.last_page;
      this.ifNotExistAnyProducts();
    },
  },
};
function activeCategory(target) {
  let currentActive = $(".categorySearch");
  currentActive.addClass("bg-white");
  currentActive.removeClass("bg-primary");
  currentActive.removeClass("text-white");
  currentActive.addClass("text-body");
  $(target).removeClass("bg-white");
  $(target).addClass("bg-primary");
  $(target).removeClass("text-body");
  $(target).addClass("text-white");
}
</script>

<style scoped>
</style>
